import React from "react";

const SocialSection = () => {
  const socials = [
    { name: "Facebook", src: "/assets/images/social/fb.svg", href: "#" },
    { name: "Instagram", src: "/assets/images/social/instagram.svg", href: "#" },
    { name: "YouTube", src: "/assets/images/social/youtube.svg", href: "#" },
    { name: "TikTok", src: "/assets/images/social/tiktok.svg", href: "#" },
    { name: "WhatsApp", src: "/assets/images/social/whatsapp.svg", href: "#" },
  ];

  return (
    <section className="py-16 px-4 bg-white text-center">
      <div className="max-w-4xl mx-auto space-y-8">
        <h2 className="text-3xl font-bold text-gray-900">Suivez-nous</h2>

        <div className="flex justify-center items-center gap-8">
          {socials.map((social, index) => (
            <a
              key={index}
              href={social.href}
              className="transition-transform transform hover:scale-110 duration-300"
              aria-label={`Follow us on ${social.name}`}
            >
              <img
                src={social.src}
                alt={social.name}
                className="w-12 h-12 object-contain"
              />
            </a>
          ))}
        </div>

        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          Restez connectés avec nous sur les réseaux sociaux pour ne rien manquer de nos actualités et promotions !
        </p>
      </div>
    </section>
  );
};

export default SocialSection;